/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumValue
 */
export interface EnumValue {
    /**
     * 
     * @type {string}
     * @memberof EnumValue
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumValue
     */
    label: string;
}

/**
 * Check if a given object implements the EnumValue interface.
 */
export function instanceOfEnumValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function EnumValueFromJSON(json: any): EnumValue {
    return EnumValueFromJSONTyped(json, false);
}

export function EnumValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
    };
}

export function EnumValueToJSON(value?: EnumValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
    };
}

